import type { ComponentProps } from "react";
import NavbarCTAButton from "./NavbarCTAButton";

interface HeroCTAButtonProps
  extends Omit<ComponentProps<typeof NavbarCTAButton>, "scrolled"> {
  children: React.ReactNode;
  onClick: () => void;
  icon?: React.ReactNode;
}

/**
 * Primary CTA button used inside the hero carousel. Solid-green pill —
 * delegates to NavbarCTAButton with scrolled=true for consistent hover style.
 */
export default function HeroCTAButton({ children, onClick, icon, ...props }: HeroCTAButtonProps) {
  return (
    <NavbarCTAButton
      scrolled={true}
      onClick={onClick}
      icon={icon}
      h={{ base: "2.85rem", tablet: "3.15rem" }}
      px={{ base: "1.2rem", tablet: "1.5rem" }}
      w={{ base: "full", tablet: "auto" }}
      minW={{ tablet: "9.5rem" }}
      fontSize={{ base: "0.9rem", tablet: "0.95rem" }}
      {...props}
    >
      {children}
    </NavbarCTAButton>
  );
}
